import React from 'react'

import { Box, Typography } from "@mui/material"


export default function multiColumn({ value, label }) {

	return {
		name: value,
		label: label,
		options: {
			customBodyRowRenderLite: value => <Box>
				{value?.map((e, idx) => <Typography key={`${idx}-${e}`}>{e}</Typography>)}
			</Box>,
		}
	}
}